/* eslint-disable prettier/prettier */

;
(function (ng) {
  'use strict';

  var CartProductItemCtrl = function ($element, $timeout, $http) {
    var ctrl = this,
      timer;
    ctrl.$onInit = function () {
      console.log(ctrl);
    };
  };
  angular.module('cart').controller('CartProductItemCtrl', CartProductItemCtrl);
  CartProductItemCtrl.$inject = ['$element', '$timeout', '$http'];
})(angular);